export default __webpack_public_path__ + "static/media/fallback-map.54e879cb.jpg";